import React from 'react';
import { Link } from 'react-router-dom';
import './SkylabFooter.css';

interface SkylabFooterProps {
  brandColor?: string;
  partnerName?: string;
}

const SkylabFooter: React.FC<SkylabFooterProps> = ({
  brandColor = '#007bff',
  partnerName = 'MyLodgeTax'
}) => {
  return (
    <footer className="skylab-footer" style={{ '--brand-color': brandColor } as React.CSSProperties}>
      <div className="footer-container">
        <div className="footer-links">
          <a href="https://www.avalara.com" className="footer-link">Avalara.com</a>
          <a href="https://www.avalara.com/mylodgetax/en/contact-us.html" className="footer-link">Contact</a>
          <a href="https://www.lodging.ci.avalara.io/legal" className="footer-link">Terms</a>
          <a href="https://www.lodging.ci.avalara.io/privacy" className="footer-link">Privacy</a>
          <Link to="/cookies" className="footer-link">Cookies</Link>
        </div>
        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} Avalara, Inc.</p>
        </div>
      </div>
    </footer>
  );
};

export default SkylabFooter; 